import React from "react";
import { Button, Col } from "react-bootstrap";
import ReactLoading from "react-loading";

import "./Buttons.css";

function BtnSave({ id, name, size, onClick, isClicked, label, disabled }) {
  return (
    <Col className="p-1">
      {isClicked ? (
        <Button
          className="action-btn loader save"
          name={name}
          id={id}
          size={size}
          disabled={disabled}
        >
          <ReactLoading type={"balls"} height={20} width={25} color="#fff" />
        </Button>
      ) : (
        <Button
          className="action-btn save"
          name={name}
          size={size}
          id={id}
          onClick={onClick}
          disabled={disabled}
        >
          {label}
        </Button>
      )}
    </Col>
  );
}

export default BtnSave;
